// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"6a535040","456":"a5db25b2","461":"d9aeeff5"}[chunkId] + ".css";
};